import { ca } from '@cian/analytics';
import { TAnalyticsSiteType } from '../../types/analytics';

export function trackShowAiBanner(siteType: TAnalyticsSiteType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'show',
    label: 'ai_summary',
    page: {
      siteType: siteType,
      pageType: 'ListingCompareJK',
    },
  });
}

export function trackClickAiBanner(siteType: TAnalyticsSiteType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'click',
    label: 'ai_summary',
    page: {
      siteType: siteType,
      pageType: 'ListingCompareJK',
    },
  });
}
